module.exports = __webpack_public_path__ + "img/6.ภาคเหนือ.3a6115e6.jpg";